import { CompetencyList } from './list'
export default CompetencyList